import React from 'react';
import { Box } from '@mui/material';
import MaintenanceTypesDashboard from '../../components/maintenance/maintenanceTypes/MaintenanceTypesDashboard';

const TiposMantenimientoPage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <MaintenanceTypesDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de tipos de mantenimiento:', newOrder);
        }}
      />
    </Box>
  );
};

export default TiposMantenimientoPage;